import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { cn } from '../../utils/cn';
import { dismissToast } from '../../store/slices/uiSlice';
import { Icon } from './Icon';

const KIND_STYLES = {
  success: { bg: 'bg-success-50 border-success-200 text-success-800', icon: 'success' },
  error: { bg: 'bg-danger-50 border-danger-200 text-danger-800', icon: 'warning' },
  warn: { bg: 'bg-warning-50 border-warning-200 text-warning-800', icon: 'warning' },
  info: { bg: 'bg-primary-50 border-primary-200 text-primary-800', icon: 'info' },
};

function ToastItem({ toast }) {
  const dispatch = useDispatch();
  useEffect(() => {
    const t = setTimeout(() => dispatch(dismissToast(toast.id)), toast.ttl);
    return () => clearTimeout(t);
  }, [dispatch, toast.id, toast.ttl]);

  const style = KIND_STYLES[toast.kind] || KIND_STYLES.info;
  return (
    <div
      className={cn(
        'flex items-start gap-2 rounded-lg border px-3 py-2 shadow-sm animate-fadein',
        style.bg,
      )}
    >
      <Icon name={style.icon} className="h-4 w-4 mt-0.5 flex-shrink-0" />
      <span className="text-sm flex-1">{toast.message}</span>
      <button
        type="button"
        onClick={() => dispatch(dismissToast(toast.id))}
        className="opacity-60 hover:opacity-100"
      >
        <Icon name="x" className="h-4 w-4" />
      </button>
    </div>
  );
}

export default function ToastContainer() {
  const toasts = useSelector((s) => s.ui.toasts);
  if (toasts.length === 0) return null;
  return (
    <div className="fixed top-4 right-4 z-50 flex w-full max-w-sm flex-col gap-2">
      {toasts.map((t) => (
        <ToastItem key={t.id} toast={t} />
      ))}
    </div>
  );
}
